import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
const updateDentalSupplierAddressesMutation = gql`mutation update_dental_supplier_addresses_by_pk($id: uuid! , $dental_supplier_addresses: dental_supplier_addresses_set_input!){
update_dental_supplier_addresses_by_pk(pk_columns:{id: $id}, _set: $dental_supplier_addresses){
    id
  }
}`;
const updateDentalProfessionalAddressesMutation = gql`mutation update_dental_professional_addresses_by_pk($id: uuid! , $dental_professional_addresses: dental_professional_addresses_set_input!){
  update_dental_professional_addresses_by_pk(pk_columns:{id: $id}, _set: $dental_professional_addresses){
      id
    }
  }`;
const updateDentalPracticeAddressesMutation = gql`mutation update_dental_practice_addresses_by_pk($id: uuid! , $dental_practice_addresses: dental_practice_addresses_set_input!){
  update_dental_practice_addresses_by_pk(pk_columns:{id: $id}, _set: $dental_practice_addresses){
      id
    }
  }`;
@Injectable({
  providedIn: 'root'
})
export class UpdateDentalSupplierAddressesService {

  constructor(private apollo: Apollo) { }
  updateDentalSupplierAddressesByPk(id: string, dental_supplier_addresses: any): Promise<any>{
    return this.apollo.use('external').mutate({
      mutation: updateDentalSupplierAddressesMutation,
      variables: {
        id,
        dental_supplier_addresses
      }
    }).toPromise()
  }

  updateDentalProfessionalAddressesByPk(id: string, dental_professional_addresses: any): Promise<any>{
    return this.apollo.use('external').mutate({
      mutation: updateDentalProfessionalAddressesMutation,
      variables: {
        id,
        dental_professional_addresses
      }
    }).toPromise()
  }

  updateDentalPracticeAddressesByPk(id: string, dental_practice_addresses: any): Promise<any>{
    return this.apollo.use('external').mutate({
      mutation: updateDentalPracticeAddressesMutation,
      variables: {
        id,
        dental_practice_addresses
      }
    }).toPromise()
  }
}

